import { render, staticRenderFns } from "./galeriaImagenes.vue?vue&type=template&id=fbfbff22&scoped=true&"
import script from "./galeriaImagenes.vue?vue&type=script&lang=js&"
export * from "./galeriaImagenes.vue?vue&type=script&lang=js&"
import style0 from "./galeriaImagenes.vue?vue&type=style&index=0&id=fbfbff22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfbff22",
  null
  
)

export default component.exports